// import React, { useState, useEffect, useCallback } from "react";
// import {
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   Pagination,
//   Card,
//   Button,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   TextField,
//   Switch,
//   CircularProgress,
//   Box,
//   Stack,
//   IconButton,
//   Modal,
//   Tooltip,
// } from "@mui/material";
// import { MdEdit, MdVisibility, MdDelete } from "react-icons/md";
// // import { MdDelete } from "react-icons/md";

// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import debounce from "lodash.debounce";

// const OfferList = () => {
//   const navigate = useNavigate();
//   const [data, setData] = useState([]);
//   const [totalPages, setTotalPages] = useState(1);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [openModal, setOpenModal] = useState(false);
//   const [selectedItem, setSelectedItem] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [deleteOpen, setDeleteOpen] = useState(false);
//   const [selectedPromocodeId, setSelectedPromocodeId] = useState(null);
//   const [formData, setFormData] = useState({
//     code: "",
//     discount_type: "",
//     discount: "",
//     minimum_bill_amount: "",
//     valid_until: "",
//     is_live: true,
//   });
//   console.log(formData, "formData");
//   useEffect(() => {
//     fetchData(currentPage, searchQuery);
//   }, [currentPage, searchQuery]);

//   const fetchData = useCallback(
//     debounce(async (page, query) => {
//       setLoading(true);
//       try {
//         const { data } = await axios.get(
//           `https://api.medstown.com/offer/promocode?page=${page}&slug=${query}`
//         );
//         console.log(data.data.promocodes);
//         setData(data.data.promocodes);
//         setTotalPages(Math.ceil(data.data.totalPromocodes / 10));
//       } catch (error) {
//         console.error("Error fetching data:", error);
//       } finally {
//         setLoading(false);
//       }
//     }, 500),
//     []
//   );

//   useEffect(() => {
//     fetchData(currentPage, searchQuery);
//   }, [currentPage, searchQuery, fetchData]);

//   const handlePageChange = (event, value) => {
//     setCurrentPage(value);
//   };

//   const handleEdit = (item) => {
//     setSelectedItem(item);
//     setFormData({
//       code: item.code,
//       discount_type: item.discount_type,
//       discount: item.discount || item.fixedPrice, // Handle both types
//       minimum_bill_amount: item.minimum_bill_amount,
//       valid_until: item.valid_until,
//       is_live: item.is_live,
//     });
//     setOpenModal(true);
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleUpdate = async () => {
//     if (!selectedItem) return;
//     setLoading(true);

//     try {
//       const response = await axios.put(
//         `https://api.medstown.com/offer/promocode/${selectedItem._id}`,
//         {
//           code: formData.code,
//           discount_type: formData.discount_type,
//           discount: formData.discount,
//           minimum_bill_amount: formData.minimum_bill_amount,
//           valid_until: formData?.valid_until,
//           is_live: formData.is_live,
//         },
//         {
//           headers: { "Content-Type": "application/json" },
//         }
//       );

//       fetchData(currentPage, searchQuery);
//       setOpenModal(false);
//     } catch (error) {
//       console.error("Error updating data:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleStatusToggle = async (item, key) => {
//     try {
//       const updatedStatus = !item[key];
//       const payload = {
//         [key]: updatedStatus,
//       };
//       if (key === "is_live" && !updatedStatus) {
//         payload.is_public = false;
//       }
//       await axios.put(
//         `https://api.medstown.com/offer/promocode/${item._id}`,
//         payload,
//         {
//           headers: { "Content-Type": "application/json" },
//         }
//       );

//       setData((prevData) =>
//         prevData.map((d) =>
//           d._id === item._id ? { ...d, [key]: updatedStatus } : d
//         )
//       );
//       if (key === "is_live" && !updatedStatus) {
//         setData((prevData) =>
//           prevData.map((d) =>
//             d._id === item._id ? { ...d, is_public: false } : d
//           )
//         );
//       }
//     } catch (error) {
//       console.error("Error updating status:", error);
//     }
//   };

//   const handleSearch = (e) => {
//     setSearchQuery(e.target.value);
//   };

//   const handleConfirmDeletePromocode = async () => {
//     try {
//       const res = await fetch(
//         `https://api.medstown.com/offer/delete_Promocode/${selectedPromocodeId}`,
//         {
//           method: "DELETE",
//         }
//       );
//       const data = await res.json();

//       if (res.ok) {
//         alert("Promocode deleted successfully");
//         // Refresh list if needed
//         fetchData(currentPage, searchQuery);
//       } else {
//         alert(data.message || "Failed to delete promocode");
//       }
//     } catch (err) {
//       alert("Server error");
//       console.error(err);
//     } finally {
//       setDeleteOpen(false);
//       setSelectedPromocodeId(null);
//     }
//   };
//   return (
//     <>
//       <Stack
//         direction="row"
//         justifyContent="space-between"
//         alignItems="center"
//         mt={2}
//       >
//         <TextField
//           variant="outlined"
//           size="small"
//           placeholder="Search Coupon code..."
//           value={searchQuery}
//           onChange={handleSearch}
//           sx={{ width: 300 }}
//         />

//         <Button
//           variant="contained"
//           color="primary"
//           onClick={() => {
//             navigate("/admin/create-offer");
//           }}
//           sx={{
//             borderRadius: "4px",
//             fontSize: "14px",
//           }}
//         >
//           Create Coupon
//         </Button>
//       </Stack>
//       <Card sx={{ marginTop: 4, py: 2 }}>
//         <TableContainer>
//           <Table>
//             <TableHead>
//               <TableRow>
//                 <TableCell style={{ fontWeight: 600, fontSize: 13 }}>
//                   Coupon Code
//                 </TableCell>
//                 <TableCell style={{ fontWeight: 600, fontSize: 13 }}>
//                   Description
//                 </TableCell>
//                 <TableCell style={{ fontWeight: 600, fontSize: 13 }}>
//                   Discount
//                 </TableCell>
//                 <TableCell style={{ fontWeight: 600, fontSize: 13 }}>
//                   Min Bill Amount
//                 </TableCell>
//                 <TableCell style={{ fontWeight: 600, fontSize: 13 }}>
//                   {" "}
//                   Valid Until
//                 </TableCell>
//                 <TableCell style={{ fontWeight: 600, fontSize: 13 }}>
//                   Status
//                 </TableCell>
//                 <TableCell style={{ fontWeight: 600, fontSize: 13 }}>
//                   Show On App
//                 </TableCell>

//                 <TableCell style={{ fontWeight: 600, fontSize: 13 }}>
//                   Action
//                 </TableCell>
//               </TableRow>
//             </TableHead>

//             <TableBody>
//               {loading ? (
//                 <TableRow>
//                   <TableCell colSpan={7} align="center">
//                     <Box display="flex" justifyContent="center" py={2}>
//                       <CircularProgress />
//                     </Box>
//                   </TableCell>
//                 </TableRow>
//               ) : (
//                 data.map((item) => (
//                   <TableRow key={item._id}>
//                     <TableCell>{item.code}</TableCell>
//                     <TableCell
//                       sx={{
//                         maxWidth: 200,
//                         whiteSpace: "nowrap",
//                         overflow: "hidden",
//                         textOverflow: "ellipsis",
//                       }}
//                     >
//                       {item.description}
//                     </TableCell>
//                     <TableCell>
//                       {item.discount_type === "fixedPrice"
//                         ? `₹${item.fixedPrice}`
//                         : `${item.discount}% (Max ₹${item.max_discount_amount})`}
//                     </TableCell>
//                     <TableCell>₹{item.minimum_bill_amount}</TableCell>
//                     {/* <Tooltip title={item?.valid_until} arrow>
//                       <TableCell
//                         style={{
//                           color:
//                             new Date(item.valid_until) < new Date()
//                               ? "red"
//                               : "inherit",
//                           fontWeight:
//                             new Date(item.valid_until) < new Date()
//                               ? "bold"
//                               : "normal",
//                         }}
//                       >
//                         {new Date(item.valid_until) < new Date()
//                           ? "Expires"
//                           : new Date(item.valid_until).toLocaleDateString(
//                               "en-GB"
//                             )}
//                       </TableCell>
//                     </Tooltip> */}
//                     <Tooltip title={item?.valid_until} arrow>
//                       <TableCell
//                         style={{
//                           color:
//                             new Date(item.valid_until)
//                               .toISOString()
//                               .slice(0, 10) <
//                             new Date().toISOString().slice(0, 10)
//                               ? "red"
//                               : "inherit",
//                           fontWeight:
//                             new Date(item.valid_until)
//                               .toISOString()
//                               .slice(0, 10) <
//                             new Date().toISOString().slice(0, 10)
//                               ? "bold"
//                               : "normal",
//                         }}
//                       >
//                         {new Date(item.valid_until).toISOString().slice(0, 10) <
//                         new Date().toISOString().slice(0, 10)
//                           ? "Expired"
//                           : new Date(item.valid_until).toLocaleDateString(
//                               "en-GB"
//                             )}
//                       </TableCell>
//                     </Tooltip>
//                     <TableCell>
//                       <Switch
//                         checked={item.is_live}
//                         onChange={() => handleStatusToggle(item, "is_live")}
//                         color="default"
//                         sx={{
//                           "& .MuiSwitch-switchBase.Mui-checked": {
//                             color: "green",
//                           },
//                           "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
//                             {
//                               backgroundColor: "green",
//                             },
//                           "& .MuiSwitch-track": {
//                             backgroundColor: "gray",
//                           },
//                         }}
//                       />
//                     </TableCell>
//                     <TableCell>
//                       <Switch
//                         checked={item.is_public}
//                         onChange={() => handleStatusToggle(item, "is_public")}
//                         color="default"
//                         sx={{
//                           "& .MuiSwitch-switchBase.Mui-checked": {
//                             color: "green",
//                           },
//                           "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
//                             {
//                               backgroundColor: "green",
//                             },
//                           "& .MuiSwitch-track": {
//                             backgroundColor: "gray",
//                           },
//                         }}
//                       />
//                     </TableCell>
//                     <TableCell>
//                       <Stack direction="row" spacing={1}>
//                         {/* Edit Button */}
//                         <IconButton
//                           onClick={() => handleEdit(item)}
//                           color="primary"
//                         >
//                           <MdEdit size={20} />
//                         </IconButton>

//                         {/* View Button */}
//                         <IconButton
//                           onClick={() =>
//                             navigate(`/admin/offer-details/${item._id}`)
//                           }
//                           color="secondary"
//                         >
//                           <MdVisibility size={20} />
//                         </IconButton>
//                         {/* Delete Button  */}
//                         <IconButton
//                           onClick={() => {
//                             setSelectedPromocodeId(item._id);
//                             setDeleteOpen(true);
//                           }}
//                           color="secondary"
//                         >
//                           <MdDelete size={20} />
//                         </IconButton>
//                       </Stack>
//                     </TableCell>
//                   </TableRow>
//                 ))
//               )}
//             </TableBody>
//           </Table>
//         </TableContainer>

//         {/* Pagination */}
//         <Pagination
//           count={totalPages}
//           page={currentPage}
//           onChange={handlePageChange}
//           sx={{ display: "flex", justifyContent: "center", marginTop: 2 }}
//         />

//         {/* Edit Modal */}
//         <Dialog open={openModal} onClose={() => setOpenModal(false)}>
//           <DialogTitle>Edit Promo Code</DialogTitle>
//           <DialogContent>
//             <TextField
//               margin="dense"
//               label="Promo Code"
//               name="code"
//               fullWidth
//               value={formData.code}
//               onChange={handleInputChange}
//             />
//             <TextField
//               margin="dense"
//               label="Discount Type"
//               name="discount_type"
//               fullWidth
//               value={formData.discount_type}
//               onChange={handleInputChange}
//             />
//             <TextField
//               margin="dense"
//               label="Discount Value"
//               name="discount"
//               type="number"
//               fullWidth
//               value={formData.discount}
//               onChange={handleInputChange}
//             />
//             {/* <TextField
//               fullWidth
//               type="date"
//               label="Valid Until"
//               name="valid_until"
//               InputLabelProps={{ shrink: true }}
//               value={formData?.valid_until}
//               onChange={handleInputChange}
//               required
//               // error={Boolean(fieldErrors.code)}
//               // helperText={fieldErrors.code}
//             /> */}
//             <TextField
//               margin="dense"
//               label="Minimum Bill Amount"
//               name="minimum_bill_amount"
//               type="number"
//               fullWidth
//               value={formData.minimum_bill_amount}
//               onChange={handleInputChange}
//             />
//             <TextField
//               margin="dense"
//               label="Valid Until"
//               name="valid_until"
//               type="date"
//               fullWidth
//               InputLabelProps={{ shrink: true }}
//               value={
//                 formData.valid_until ? formData.valid_until.slice(0, 10) : ""
//               }
//               onChange={handleInputChange}
//             />
//           </DialogContent>
//           <DialogActions>
//             <Button onClick={() => setOpenModal(false)}>Cancel</Button>
//             <Button onClick={handleUpdate} color="primary">
//               {loading ? <CircularProgress size={20} /> : "Update"}
//             </Button>
//           </DialogActions>
//         </Dialog>
//       </Card>
//       {/* delete modal */}
//       <Modal
//         open={deleteOpen}
//         onClose={() => {
//           setDeleteOpen(false);
//           setSelectedPromocodeId(null);
//         }}
//         aria-labelledby="delete-promocode-title"
//         aria-describedby="delete-promocode-description"
//       >
//         <Box sx={deleteModalStyle}>
//           <h4 className="text-2xl font-bold">Delete Promocode</h4>
//           <p>
//             Are you sure you want to delete this promocode? This action cannot
//             be undone.
//           </p>
//           <Box className="mt-4 flex justify-end gap-2">
//             <Button
//               onClick={handleConfirmDeletePromocode}
//               variant="contained"
//               color="error"
//             >
//               Delete
//             </Button>
//             <Button
//               onClick={() => {
//                 setDeleteOpen(false);
//                 setSelectedPromocodeId(null);
//               }}
//               variant="outlined"
//             >
//               Cancel
//             </Button>
//           </Box>
//         </Box>
//       </Modal>
//     </>
//   );
// };
// const deleteModalStyle = {
//   position: "absolute",
//   top: "50%",
//   left: "50%",
//   transform: "translate(-50%, -50%)",
//   width: 400,
//   bgcolor: "background.paper",
//   borderRadius: 2,
//   boxShadow: 24,
//   p: 4,
// };
// export default OfferList;



import React, { useState, useEffect, useCallback } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Pagination,
  Card,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Switch,
  CircularProgress,
  Box,
  Stack,
  IconButton,
  Modal,
  Tooltip,
  Typography,
  alpha,
  useTheme,
  FormControlLabel
} from "@mui/material";
import { MdEdit, MdVisibility, MdDelete, MdAdd } from "react-icons/md";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import debounce from "lodash.debounce";

const medstownColors = {
  primary: "#014D4D",
  secondary: "#02A0A0",
  accent: "#FFB800",
  success: "#4caf50",
  error: "#f44336",
  warning: "#ff9800",
  white: "#fff",
};

const deleteModalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  borderRadius: 2,
  boxShadow: 24,
  p: 4,
};

const OfferList = () => {
  const theme = useTheme();
  const navigate = useNavigate();

  const [data, setData] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [openModal, setOpenModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [selectedPromocodeId, setSelectedPromocodeId] = useState(null);
  const [formData, setFormData] = useState({
    code: "",
    discount_type: "",
    discount: "",
    minimum_bill_amount: "",
    valid_until: "",
    is_live: true,
  });

  // Debounced fetch data
  const fetchData = useCallback(
    debounce(async (page, query) => {
      setLoading(true);
      try {
        const { data } = await axios.get(
          `https://api.medstown.com/offer/promocode?page=${page}&slug=${query}`
        );
        setData(data.data.promocodes);
        setTotalPages(Math.ceil(data.data.totalPromocodes / 10));
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    }, 400),
    []
  );

  useEffect(() => {
    fetchData(currentPage, searchQuery);
  }, [currentPage, searchQuery, fetchData]);

  const handlePageChange = (event, value) => setCurrentPage(value);

  const handleSearch = (e) => setSearchQuery(e.target.value);

  const handleEdit = (item) => {
    setSelectedItem(item);
    setFormData({
      code: item.code,
      discount_type: item.discount_type,
      discount: item.discount || item.fixedPrice,
      minimum_bill_amount: item.minimum_bill_amount,
      valid_until: item.valid_until,
      is_live: item.is_live,
    });
    setOpenModal(true);
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleUpdate = async () => {
    if (!selectedItem) return;
    setLoading(true);
    try {
      await axios.put(
        `https://api.medstown.com/offer/promocode/${selectedItem._id}`,
        {
          code: formData.code,
          discount_type: formData.discount_type,
          discount: formData.discount,
          minimum_bill_amount: formData.minimum_bill_amount,
          valid_until: formData.valid_until,
          is_live: formData.is_live,
        },
        { headers: { "Content-Type": "application/json" } }
      );
      fetchData(currentPage, searchQuery);
      setOpenModal(false);
    } catch (error) {
      console.error("Error updating data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleStatusToggle = async (item, key) => {
    try {
      const updatedStatus = !item[key];
      const payload = {
        [key]: updatedStatus,
      };
      if (key === "is_live" && !updatedStatus) {
        payload.is_public = false;
      }
      await axios.put(
        `https://api.medstown.com/offer/promocode/${item._id}`,
        payload,
        { headers: { "Content-Type": "application/json" } }
      );

      setData((prev) =>
        prev.map((d) => (d._id === item._id ? { ...d, [key]: updatedStatus } : d))
      );
      if (key === "is_live" && !updatedStatus) {
        setData((prev) =>
          prev.map((d) => (d._id === item._id ? { ...d, is_public: false } : d))
        );
      }
    } catch (error) {
      console.error("Error updating status:", error);
    }
  };

  const handleConfirmDeletePromocode = async () => {
    try {
      const res = await fetch(
        `https://api.medstown.com/offer/delete_Promocode/${selectedPromocodeId}`,
        { method: "DELETE" }
      );
      const data = await res.json();

      if (res.ok) {
        alert("Promocode deleted successfully");
        fetchData(currentPage, searchQuery);
      } else {
        alert(data.message || "Failed to delete promocode");
      }
    } catch (err) {
      alert("Server error");
      console.error(err);
    } finally {
      setDeleteOpen(false);
      setSelectedPromocodeId(null);
    }
  };

  return (
    <>
      {/* Header */}
      <Paper
        elevation={4}
        sx={{
          py: 2,
          px: 3,
          mb: 3,
          borderRadius: 3,
          background: `linear-gradient(135deg, ${medstownColors.primary}, ${medstownColors.secondary})`,
          color: medstownColors.white,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          gap: 2,
          boxShadow: `0 8px 24px ${alpha(medstownColors.primary, 0.3)}`,
        }}
      >
        <Typography variant="h5" fontWeight="bold" sx={{ letterSpacing: "-0.02em" }}>
          Promo Codes Management
        </Typography>
        <Button
          startIcon={<MdAdd />}
          variant="outlined"
          sx={{
            color: medstownColors.white,
            borderColor: medstownColors.white,
            fontWeight: 600,
            "&:hover": { borderColor: alpha(medstownColors.white, 0.7) },
          }}
          onClick={() => navigate("/admin/create-offer")}
        >
          Create Coupon
        </Button>
      </Paper>

      {/* Search & actions */}
      <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2} flexWrap="wrap" gap={2}>
        <TextField
          value={searchQuery}
          onChange={handleSearch}
          placeholder="Search Coupon code..."
          variant="outlined"
          size="small"
          sx={{ width: 300, minWidth: "240px" }}
        />
      </Stack>

      {/* Table */}
      <Card sx={{ py: 2 }}>
        <TableContainer>
          <Table size="small" sx={{ borderCollapse: "separate", borderSpacing: "0 8px" }}>
            <TableHead>
              <TableRow sx={{ backgroundColor: alpha(medstownColors.primary, 0.1) }}>
                {[
                  "Coupon Code",
                  "Description",
                  "Discount",
                  "Min Bill Amount",
                  "Valid Until",
                  "Status",
                  "Show On App",
                  "Actions",
                ].map((headCell) => (
                  <TableCell
                    key={headCell}
                    sx={{
                      fontWeight: 600,
                      fontSize: 13,
                      whiteSpace: "nowrap",
                      paddingY: 1,
                      paddingX: 2,
                      color: medstownColors.primary,
                      textTransform: "uppercase",
                      letterSpacing: "0.04em",
                    }}
                  >
                    {headCell}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell colSpan={8} align="center" sx={{ py: 3 }}>
                    <CircularProgress />
                  </TableCell>
                </TableRow>
              ) : data.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={8} align="center" sx={{ py: 4, fontStyle: "italic" }}>
                    No coupons found.
                  </TableCell>
                </TableRow>
              ) : (
                data.map((item) => (
                  <TableRow
                    key={item._id}
                    sx={{
                      backgroundColor: "#fff",
                      borderRadius: 2,
                      "&:hover": {
                        backgroundColor: alpha(medstownColors.primary, 0.08),
                        boxShadow: `0 2px 12px ${alpha(medstownColors.primary, 0.1)}`,
                        cursor: "pointer",
                      },
                    }}
                  >
                    <TableCell>{item.code}</TableCell>
                    <TableCell
                      sx={{
                        maxWidth: 180,
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        fontSize: 13,
                      }}
                      title={item.description}
                    >
                      {item.description}
                    </TableCell>
                    <TableCell sx={{ fontSize: 13 }}>
                      {item.discount_type === "fixedPrice"
                        ? `₹${item.fixedPrice}`
                        : `${item.discount}% (Max ₹${item.max_discount_amount})`}
                    </TableCell>
                    <TableCell sx={{ fontSize: 13 }}>₹{item.minimum_bill_amount}</TableCell>
                    <Tooltip title={item.valid_until} arrow>
                      <TableCell
                        sx={{
                          color:
                            new Date(item.valid_until).toISOString().slice(0, 10) <
                            new Date().toISOString().slice(0, 10)
                              ? medstownColors.error
                              : "inherit",
                          fontWeight:
                            new Date(item.valid_until).toISOString().slice(0, 10) <
                            new Date().toISOString().slice(0, 10)
                              ? "bold"
                              : "normal",
                          fontSize: 13,
                          whiteSpace: "nowrap",
                        }}
                      >
                        {new Date(item.valid_until).toISOString().slice(0, 10) <
                        new Date().toISOString().slice(0, 10)
                          ? "Expired"
                          : new Date(item.valid_until).toLocaleDateString("en-GB")}
                      </TableCell>
                    </Tooltip>
                    <TableCell>
                      <Switch
                        checked={item.is_live}
                        onChange={() => handleStatusToggle(item, "is_live")}
                        color="success"
                        size="small"
                        sx={{
                          "& .MuiSwitch-switchBase.Mui-checked": {
                            color: medstownColors.success,
                          },
                          "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                            backgroundColor: alpha(medstownColors.success, 0.5),
                          },
                          "& .MuiSwitch-track": {
                            backgroundColor: alpha("#999", 0.3),
                          },
                        }}
                      />
                    </TableCell>
                    <TableCell>
                      <Switch
                        checked={item.is_public}
                        onChange={() => handleStatusToggle(item, "is_public")}
                        color="success"
                        size="small"
                        sx={{
                          "& .MuiSwitch-switchBase.Mui-checked": {
                            color: medstownColors.success,
                          },
                          "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                            backgroundColor: alpha(medstownColors.success, 0.5),
                          },
                          "& .MuiSwitch-track": {
                            backgroundColor: alpha("#999", 0.3),
                          },
                        }}
                      />
                    </TableCell>
                    <TableCell>
                      <Stack direction="row" spacing={1} justifyContent="center">
                        <Tooltip title="Edit">
                          <IconButton onClick={() => handleEdit(item)} color="primary" size="small">
                            <MdEdit size={20} />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="View Details">
                          <IconButton
                            onClick={() => navigate(`/admin/offer-details/${item._id}`)}
                            color="secondary"
                            size="small"
                          >
                            <MdVisibility size={20} />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Delete">
                          <IconButton
                            onClick={() => {
                              setSelectedPromocodeId(item._id);
                              setDeleteOpen(true);
                            }}
                            color="error"
                            size="small"
                          >
                            <MdDelete size={20} />
                          </IconButton>
                        </Tooltip>
                      </Stack>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Pagination */}
        <Pagination
          count={totalPages}
          page={currentPage}
          onChange={handlePageChange}
          sx={{ display: "flex", justifyContent: "center", mt: 2 }}
          size="small"
          color="primary"
          siblingCount={0}
          boundaryCount={1}
        />
      </Card>

      {/* Edit Modal */}
      <Dialog open={openModal} onClose={() => setOpenModal(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Edit Coupon</DialogTitle>
        <DialogContent dividers>
          <Stack spacing={2}>
            <TextField
              label="Coupon Code"
              name="code"
              value={formData.code}
              onChange={handleInputChange}
              fullWidth
              size="small"
            />
            <TextField
              label="Discount Type"
              name="discount_type"
              value={formData.discount_type}
              onChange={handleInputChange}
              fullWidth
              size="small"
            />
            <TextField
              label="Discount Value"
              name="discount"
              value={formData.discount}
              onChange={handleInputChange}
              type="number"
              fullWidth
              size="small"
            />
            <TextField
              label="Minimum Bill Amount"
              name="minimum_bill_amount"
              value={formData.minimum_bill_amount}
              onChange={handleInputChange}
              type="number"
              fullWidth
              size="small"
            />
            <TextField
              label="Valid Until"
              name="valid_until"
              type="date"
              InputLabelProps={{ shrink: true }}
              value={formData.valid_until ? formData.valid_until.slice(0, 10) : ""}
              onChange={handleInputChange}
              fullWidth
              size="small"
            />
            <FormControlLabel
              control={
                <Switch
                  checked={formData.is_live}
                  onChange={(e) =>
                    setFormData((prev) => ({ ...prev, is_live: e.target.checked }))
                  }
                  color="primary"
                />
              }
              label="Live Status"
            />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenModal(false)}>Cancel</Button>
          <Button onClick={handleUpdate} variant="contained" color="primary" disabled={loading}>
            {loading ? <CircularProgress size={20} /> : "Update"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Delete Confirmation Modal */}
      <Modal
        open={deleteOpen}
        onClose={() => {
          setDeleteOpen(false);
          setSelectedPromocodeId(null);
        }}
        aria-labelledby="delete-promocode-title"
        aria-describedby="delete-promocode-description"
      >
        <Box sx={deleteModalStyle}>
          <Typography variant="h6" fontWeight="bold" mb={2}>
            Delete Promocode
          </Typography>
          <Typography mb={4}>
            Are you sure you want to delete this promocode? This action cannot be undone.
          </Typography>
          <Stack direction="row" justifyContent="flex-end" spacing={2}>
            <Button
              variant="outlined"
              onClick={() => {
                setDeleteOpen(false);
                setSelectedPromocodeId(null);
              }}
            >
              Cancel
            </Button>
            <Button variant="contained" color="error" onClick={handleConfirmDeletePromocode}>
              Delete
            </Button>
          </Stack>
        </Box>
      </Modal>
    </>
  );
};

export default OfferList;
